import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { t as i18nT } from "../../i18n";


const AdminDashboard = () => {
  const navigate = useNavigate();

  const goToGameAdmin = useCallback(() => {
    navigate("/game?tab=admin");
  }, [navigate]);

  return (
    <div className="flex h-full items-center justify-center bg-[#070f24e6] p-6">
      <div className="w-full max-w-lg rounded border border-[#24406f] bg-[#0c1f3e] p-4 text-center">
        <h1 className="mb-2 text-xl font-black uppercase tracking-[0.16em] text-[#f2bf73]">{i18nT("common.panelDeAdministracion")}</h1>
        <p className="mb-4 text-sm text-[#d4edff]">{i18nT("common.laAdministracionDeSalasDesafiosIndependientea02fbe")}</p>
        <button
          type="button"
          onClick={goToGameAdmin}
          className="rounded border border-[#4fc3ff88] bg-[#11305c] px-3 py-2 text-xs font-semibold uppercase tracking-wide text-[#b7e4ff] transition hover:border-[#7ee5ff] hover:text-white"
        >{i18nT("common.irAlPanelAdmin")}</button>
      </div>
    </div>
  );
};

export default AdminDashboard;
